import { Carousel } from "react-responsive-carousel";
import { Icons } from "components";

// Carousel from react-responsive-carousel to make slider
// renderArrowPrev and renderArrowNext to set slider arrow

export default function Slider({children}) {
  return (
    <>
      {children?.length > 1 ? (
        <Carousel
          infiniteLoop={true}
          autoPlay={true}
          showArrows={true}
          emulateTouch={false}
          swipeable={true}
          preventMovementUntilSwipeScrollTolerance={true}
          renderArrowPrev={(clickHandler) => (
            <div className="control-arrow control-prev" onClick={clickHandler}>
              <Icons.Prev />
            </div>
          )}
          renderArrowNext={(clickHandler) => (
            <div className="control-arrow control-next" onClick={clickHandler}>
              <Icons.Next />
            </div>
          )}
        >
          {children}
        </Carousel>
      ) : (
        <div className="mb-4">
          {children}
        </div>
      )}
    </>
  );
}
